export const SET_MESSAGES = "SET_MESSAGES";
export const NEW_MESSAGE = "NEW_MESSAGE";
export const UPDATE_MESSAGE_MEDIA_URL = "UPDATE_MESSAGE_MEDIA_URL";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const UNREAD_COUNT = "UNREAD_COUNT";
export const SET_CONVERSATIONS = "SET_CONVERSATIONS"
export const UPDATE_CONVERSATION_COUNT = "UPDATE_CONVERSATION_COUNT"
